export const NAV_ROOT = "/";
export const NAV_STAFF = "/staff";
export const NAV_SWITCH_ORG = "/switch-org";
export const NAV_UPDATE_CHECK = "/update-check";
export const NAV_MOBILE_WELCOME = "/mobile-welcome";
